import React, { useContext, useCallback,useState, useEffect } from 'react';
import { ViewModelForm ,ViewModelServiceContext, useDataRefresh} from 'gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import{
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalNextProvider,
    ButtonLink
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import styles from './PaperlessDistibutionComponent.module.scss';
import metadata from './PaperlessDistibutionComponent.metadata.json5';
import messages from './PaperlessDistibutionComponent.messages';
import { Link } from 'react-router-dom';



const PaperlessDistibutionComponent = (props) => {
    const {
        isOpen,
        authHeader,
        data,
        onReject,
        onResolve,
        history
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    useEffect(() => {
      
    // only execute once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleClose = useCallback(async () => {
        await onResolve(true);
        await onReject();
        // const location = {
        //     pathname: "/go-paperless",
        //     state: showNotification || {}
        //  }
        // history.push(location);
    }, [onReject,onResolve]);

    const optOut =useCallback(async () => {
        await onResolve(false);
        await onReject();
        // const location = {
        //     pathname: "/go-paperless",
        //     state: showNotification || {}
        //  }
        // history.push(location);
      
    },[onReject,onResolve]);

    const getPopBodyContent =()=>{
        return( 
        <div id="popup" class="popup-backdrop">
        <div class="popup">
          <h2>You’re in control.</h2>
          <p>Want faster access to your documents and less paper? You can choose to receive your policies, renewals, changes, and invoices electronically—right here through your secure Portal.</p>
          <ul>
            <li>Instant access as soon as they’re ready</li>
            <li>View anytime, from anywhere</li>
            <li>Email alerts when something new is available</li>
            <li>Less paper clutter and more convenience</li>
          </ul>
          <p>Select how you’d like to receive your documents going forward:</p>
          </div>
          </div>)
    }

    const overrideProps = {
        policyDocPoupBody:{
            content: getPopBodyContent()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            optOut
        }
    };

    return (
        <ModalNext className={styles.paperlessModalBoxWidth} isOpen={isOpen}>
            <ModalHeader
             title={translator(messages.setPaperLessTitle)} 
             status ='success'
             icon="mi-mail" />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.componentContent.content}
                   // model={data}
                    overrideProps={overrideProps}
                    // onModelChange={handleVMChange}
                    // onValueChange ={handleChange}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </ModalBody>
            <ModalFooter>
            <Button onClick={optOut}  type="secondary">
                  {translator(messages.optOut)}
                </Button>
                <Button onClick={handleClose}>
                {translator(messages.agree)}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

PaperlessDistibutionComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string
    }).isRequired,
    onResolve: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    onReject: PropTypes.func.isRequired
};
PaperlessDistibutionComponent.defaultProps = {
    isOpen: false,
    onReject: _.noop,
};
export default withAuthenticationContext(PaperlessDistibutionComponent);
